<div class="container">
	<div class="row">
		<div class="col-12">
			<a routerLink="/" class="app-logo logo" title="Specialized Auth"></a>
		</div>
	</div>
</div>

<div class="d-flex align-items-center form-centering" role="main">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-12 col-lg-6">
				<!-- Request reset password form -->
				<div class="container" *ngIf="!code">
					<form [formGroup]="requestInputs" (ngSubmit)="requestResetPassword()">
						<div class="row">
							<h1 class="col-12">
								<span i18n="reset your password form title|form title for resetting users password">Reset your password here</span>
							</h1>

							<div class="col-12 top-margin-20">
								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n>Email address</mat-label>
									<input
										matInput
										type="email"
										autocomplete="username"
										placeholder="jo@example.com"
										i18n-placeholder
										formControlName="email"
									/>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.email"
										[errorFormControl]="requestInputs.controls.email"
									></mat-error>
								</mat-form-field>
							</div>
						</div>
						<div class="row two-columns">
							<div class="col-md-6 top-margin-30 order-md-2">
								<button
									*ngIf="!requested"
									mat-flat-button
									color="primary"
									class="width-100"
									type="submit"
								>
									<span i18n="request reset button|button title to submit the reset password request form"
										>Request reset</span
									>
								</button>
								<button *ngIf="requested" mat-flat-button color="primary" [disabled]="true" class="width-100" type="button">
									<span class="material-icons text-succes">check_circle</span>
								</button>
							</div>
							<div class="col-md-6 top-margin-30 order-md-1">
								<button mat-flat-button type="button" class="width-100" routerLink="/login">
									<span i18n="return to sign in screen|link to the sign in screen">Return to sign in</span>
								</button>
							</div>
						</div>
					</form>
				</div>
				<!-- END Request reset password form -->

				<!-- Reset password form -->
				<div class="container" *ngIf="code">
					<form [formGroup]="resetInputs" (ngSubmit)="resetPassword()">
						<div class="row">
							<h1 class="col-12">
								<span i18n="enter new password title|form title for entering new password">Enter your new password</span>
							</h1>

							<div class="col-12 top-margin-20">
								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n>Email address</mat-label>
									<input
										matInput
										type="email"
										autocomplete="username"
										placeholder="jo@example.com"
										i18n-placeholder
										formControlName="email"
									/>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.email"
										[errorFormControl]="resetInputs.controls.email"
									></mat-error>
								</mat-form-field>
								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n>Password</mat-label>
									<input
										matInput
										autocomplete="new-password"
										[type]="hidePassword ? 'password' : 'text'"
										formControlName="password"
									/>
									<button
										mat-icon-button
										matSuffix
										(click)="hidePassword = !hidePassword"
										i18n-title="show/hide password button"
										title="Show/Hide password"
										[attr.aria-pressed]="hidePassword"
										type="button"
									>
										<mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
									</button>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.password"
										[errorFormControl]="resetInputs.controls.password"
									></mat-error>
								</mat-form-field>
								<mat-form-field appearance="standard" class="width-100">
									<mat-label i18n="confirm password form input|label to describe the confirm password input field">Confirm password</mat-label>
									<input
										matInput
										autocomplete="new-password"
										[type]="hidePassword ? 'password' : 'text'"
										formControlName="password2"
									/>
									<mat-error
										appFormErrorMessage
										[type]="formEditorInputType.password"
										[errorFormControl]="resetInputs.controls.password2"
									></mat-error>
								</mat-form-field>
							</div>
						</div>
						<div class="row two-columns">
							<div class="col-md-6 top-margin-30 order-md-2">
								<button
									mat-flat-button
									color="primary"
									class="width-100"
									type="submit"
								>
									<span i18n="submit reset form button|button title to submit the reset password form">Reset password</span>
								</button>
							</div>
							<div class="col-md-6 top-margin-30 order-md-1">
								<button mat-flat-button type="button" class="width-100" routerLink="/login">
									<span i18n="return to sign in screen|link to the sign in screen">Return to sign in</span>
								</button>
							</div>
						</div>
					</form>
				</div>
				<!-- END Reset password form -->
			</div>
		</div>
	</div>
</div>

<div class="build-version">
	<app-build-version></app-build-version>
</div>
